module.exports = __webpack_public_path__ + "static/media/typeBVersion2.beb28013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/landing/typeBVersion2.png
// module id = 1249
// module chunks = 0